module.exports = __webpack_public_path__ + "static/img/2.4ac7631.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/2/sp/2.png
// module id = es0v
// module chunks = 0